import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";
import { PartnerInvitedUser } from "./PartnerInvitationModal.d";

export const EMPTY_PARTNER_INVITED_USER: PartnerInvitedUser = { email: "", last_name: "", first_name: "" };

export const isPartnerInvitedUserValid = (user: PartnerInvitedUser) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email.trim()) && !!user.last_name.trim() && !!user.first_name.trim();

export const invitePartnerUsersToEvaluation = (
  evaluationId: string,
  users: Array<PartnerInvitedUser>,
  setLoading: Function,
  onSuccess: Function,
  language: string
) => {
  setLoading(true);

  ApiService.post("partners/mine/evaluations/attempts", {
    users: users.map((user) => ({
      email: user.email.trim(),
      last_name: user.last_name.trim(),
      first_name: user.first_name.trim(),
    })),
    evaluations: [Number(evaluationId)],
  })
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error inviting users to partner evaluation:", error);
      alert(error?.data?.error?.message || translate(language, "PAGES.EVALUATION.PARTNER_INVITATION_MODAL.ERROR"));
    })
    .finally(() => setLoading(false));
};
